export enum PlatformLanguageCode {
  English = 'en',
  Hebrew = 'he',
}

export const platformDefaultLanguageCode = PlatformLanguageCode.English;
export const supportedPlatformLanguageCodes = [
  PlatformLanguageCode.English,
  PlatformLanguageCode.Hebrew,
] as const;

export type SupportedPlatformLanguageCode =
  (typeof supportedPlatformLanguageCodes)[number];

export type LocalizationLocaleSource =
  | 'actor_preference'
  | 'occasion_default'
  | 'system_default'
  | 'explicit_request';

export interface ResolvedLocalizationContext {
  requestedLocaleCode: string | null;
  preferredLocaleCode: string | null;
  resolvedLocaleCode: string;
  localeSource: LocalizationLocaleSource;
  fallbackLocaleCodes: string[];
}

export interface ActorLocalePreferenceSummary {
  actorId: string;
  preferredLocaleCode: string | null;
  updatedAt: string | null;
}

export type LocalizedTextValue = Record<string, string>;

export type LocalizedResourceContentKind =
  | 'actor'
  | 'form'
  | 'rsvp_invitation'
  | 'shared_planning_board'
  | 'shared_planning_item'
  | 'timeline_item'
  | 'occasion_location'
  | 'registry_item'
  | 'guest_website_identity'
  | 'guest_website_nav_item'
  | 'guest_website_section'
  | 'publishing_draft';

export interface OccasionLanguageRecord {
  id: string;
  occasionId: string;
  localeCode: string;
  isPrimary: boolean;
  position: number;
}

export interface OccasionLanguageInput {
  localeCode: string;
  isPrimary: boolean;
  position: number;
}

export interface OccasionLocalizedContentRecord {
  id: string;
  occasionId: string;
  displayName: LocalizedTextValue;
  description: LocalizedTextValue;
  welcomeMessage: LocalizedTextValue;
  createdAt: string;
  updatedAt: string;
}

export interface OccasionLocalizedContentInput {
  displayName: LocalizedTextValue;
  description: LocalizedTextValue;
  welcomeMessage: LocalizedTextValue;
}

export interface EventLocalizedContentRecord {
  id: string;
  eventId: string;
  displayName: LocalizedTextValue;
  description: LocalizedTextValue;
  guestSummary: LocalizedTextValue;
  locationName: LocalizedTextValue;
  locationAddress: LocalizedTextValue;
  createdAt: string;
  updatedAt: string;
}

export interface EventLocalizedContentInput {
  displayName: LocalizedTextValue;
  description: LocalizedTextValue;
  guestSummary: LocalizedTextValue;
  locationName: LocalizedTextValue;
  locationAddress: LocalizedTextValue;
}

export interface LocalizedResourceContentRecord {
  id: string;
  occasionId: string;
  resourceKind: LocalizedResourceContentKind;
  resourceId: string;
  fields: Record<string, LocalizedTextValue>;
  createdAt: string;
  updatedAt: string;
}

export interface LocalizedResourceContentInput {
  fields: Record<string, LocalizedTextValue>;
}
